import { IContextualMenuItem, mergeStyles } from "@fluentui/react";
import { toast } from "components/FluentToast";
import { useSetFleetCancellationStatus } from "hooks/data/mutations/useSetFleetCancellationStatus";
import { useQuery } from "hooks/useQuery";
import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

import {
  CenteredCell,
  ListContextMenuIconButton,
} from "../../../components/styled";
import { routes } from "../../../config/routes";
import {
  loadFleetsActions,
  setDeleteDialog,
  setDuplicateFleetDialog,
  setMoveFleetDialog,
} from "../../../store/fleetsPage";
import { useSelector } from "../../../store/hooks";
import { Fleet, UserRole } from "../../../types/types";

export const ContextButtonFleets = ({ fleet }: { fleet: Fleet }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const userRole = useSelector((s) => s.auth.userRole);
  const query = useQuery();
  const { mutate: setCancellationStatus } = useSetFleetCancellationStatus();

  const items: IContextualMenuItem[] = [
    {
      key: "open",
      text: t("bfm.openInNewTab.label"),
      onClick: () => {
        window.open(routes.fleet.getPath(fleet?.fleetId));
      },
    },
    {
      key: "edit",
      text: t("bfm.editVehicle.label"),
      onClick: () => {
        navigate(routes.editFleet.getPath(fleet.fleetId));
      },
    },
    {
      key: "delete",
      text: t("bfm.deleteTempVehicle.label"),
      onClick: () => {
        dispatch(
          setDeleteDialog({
            isOpen: true,
            fleet,
          }),
        );
      },
      className: userRole !== UserRole.admin ? displayNoneClass : "",
    },
    {
      key: "cancelFleet",
      text: fleet?.isCancelled
        ? t("bfm.uncancelFleet.label")
        : t("bfm.cancelFleet.label"),
      onClick: () => {
        const clientId = query.get("clientId");
        setCancellationStatus(
          {
            fleetId: fleet.fleetId,
            isCancelled: !fleet.isCancelled,
          },
          {
            onSuccess: () => {
              dispatch(loadFleetsActions.trigger({ clientId }));
              toast.success(t("bfm.success"));
            },
          },
        );
      },
      className: userRole !== UserRole.admin ? displayNoneClass : "",
    },
    {
      key: "moveFleetToAnotherClient",
      text: t("bfm.moveFleetToAnotherClient.label"),
      onClick: () => {
        dispatch(
          setMoveFleetDialog({
            isOpen: true,
            fleet,
          }),
        );
      },
      className: userRole !== UserRole.admin ? displayNoneClass : "",
    },
    {
      key: "duplicateFleet",
      text: t("bfm.duplicateFleet.label"),
      onClick: () => {
        dispatch(
          setDuplicateFleetDialog({
            isOpen: true,
            fleet,
          }),
        );
      },
      className: userRole !== UserRole.admin ? displayNoneClass : "",
    },
  ];

  return (
    <CenteredCell>
      <ListContextMenuIconButton
        iconProps={{ iconName: "MoreVertical" }}
        menuIconProps={{ style: { display: "none" } }}
        menuProps={{
          items: items,
        }}
      />
    </CenteredCell>
  );
};

const displayNoneClass = mergeStyles({
  display: "none",
});
